/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Display.Masks
 */

module.exports = {

    BitmapMask: require('./BitmapMask'),
    GeometryMask: require('./GeometryMask')

};



//////////////////
// WEBPACK FOOTER
// ./display/mask/index.js
// module id = 518
// module chunks = 0